export enum CargoCompanyAddressUpdateRequestType {
  HOTEL = "HOTEL",
  STATION = "STATION",
  MEETING_POINT = "MEETING_POINT",
}

export type CargoCompanyAddressUpdateRequestBody = {
  lat: number;
  lon: number;
  country: string | null;
  town: string | null;
  zipCode: string | null;
  street: string | null;
  houseNo: string | null;
  apartment: string | null;
  description: string | null;
  type: CargoCompanyAddressUpdateRequestType;
};

type CargoCompanyAddressUpdateRequest = {
  cargoCompanyUuid: string;
  addressUuid: string;
  lat: number;
  lon: number;
  country: string | null;
  town: string | null;
  zipCode: string | null;
  street: string | null;
  houseNo: string | null;
  apartment: string | null;
  description: string | null;
  type: CargoCompanyAddressUpdateRequestType;
};

export default CargoCompanyAddressUpdateRequest;
